import styled from 'styled-components';

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px;

  .filter_card {
    overflow: visible !important;
  }

  .with_line {
    position: relative;
    margin-bottom: 8px;

    &::before {
      content: '';
      width: 12px;
      height: 1px;
      background-color: #e9ecef;
      position: absolute;
      left: -12px;
      top: 5px;
    }
  }

  .operator {
    display: flex;
    padding-left: 34px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 300px;

    label {
      color: #25262b;
      font-size: 12px;
      font-weight: 600;
      line-height: 12.13px;
      text-align: left;
      margin: 0;
    }

    .form-element {
      min-width: 78px;
    }
  }

  .element {
    display: flex;
    align-items: flex-end;
    width: 100%;
    gap: 5px;
    padding-left: 5px;
    max-width: 300px;

    .input_wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 4px;

      label {
        color: #25262b;
        font-size: 12px;
        font-weight: 600;
        line-height: 12.13px;
        text-align: left;
        margin: 0;
      }
    }

    .form-element {
      flex: 1;
      gap: 4px;

      /* .select,
      .input {
        background-color: #cde0ff;
      } */
    }

    .checkbox_line {
      display: flex;
      align-items: center;
      gap: 3px;
      position: relative;
      margin-bottom: 8px;
      padding-left: 8px;

      &::after {
        content: '';
        width: 10px;
        height: 1px;
        background-color: #e9ecef;
        position: absolute;
        left: -10px;
        top: 7px;
      }

      .checkbox {
        margin: 0;
        margin-bottom: 5px;
      }

      .line {
        width: 4px;
        height: 1px;
        border-top: 1px solid #e9ecef;
      }
    }

    label {
      display: flex;
      gap: 5px;
      align-items: flex-start;
      margin-bottom: 0 !important;
      margin-left: 5px;

      &:last-child {
        margin-bottom: 5px;
      }

      input {
        margin: 0;
      }
    }
  }
`;

export const ArithmeticWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ArithmeticBody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;

  ${({ isChild }) =>
    isChild &&
    `
    border-radius:  4px;
    padding: 6px;
    margin-left: 6px;


    .with_line {
      padding-left: 8px;
    }
  `}

  .box {
    flex: 1;
    padding: 6px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;

    &.child {
      background-color: #f8f9fa;
      padding: 16px;

      &::after {
        content: '';
        position: absolute;
        left: 16px;
        width: 1px;
        height: ${({ isConcatenate }) =>
          isConcatenate ? 'calc(100% - 59px)' : 'calc(100% - 82px)'};
        background-color: #e9ecef;
        top: ${({ isConcatenate }) => (isConcatenate ? '41px' : '55px')};
      }
    }

    &::after {
      content: '';
      position: absolute;
      left: 6px;
      width: 1px;
      height: ${({ isConcatenate }) => (isConcatenate ? 'calc(100% - 59px)' : 'calc(100% - 42px)')};
      background-color: #e9ecef;
      top: ${({ isConcatenate }) => (isConcatenate ? '41px' : '25px')};
    }
  }

  .result {
    width: 141px;
    gap: 4px;

    .form-element {
      flex: 1;

      /* .select {
        background-color: #cde0ff;
      } */
    }

    label {
      color: #25262b;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
`;

export const ArithmeticFormulaStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 8px 12px;
  border-radius: 4px;
  gap: 4px;
  background: #f1f3f5;
  color: #40c057;

  .condition {
    background-color: #dff2e8;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #40c057;
    background: #fff;

    color: #40c057;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 16.8px */
  }
`;

export const ArithmeticContainer = styled.div`
  border-bottom: 1px solid #f1f3f5;
`;
